// extracted by mini-css-extract-plugin
export default {"firstScreenRightCon":"firstScreenRightCon--hOzAI","scoreModule":"scoreModule--iMb96","markerAnimationScale":"markerAnimationScale--AgWUH"};